import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/docgen/purchaseorder'
import pathMap from 'src/paths/pathMap'

class DocGenPurchaseOrderRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.DOC_GEN_PURCHASE_ORDER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.DOC_GEN_PURCHASE_ORDER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.DOC_GEN_PURCHASE_ORDER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.DOC_GEN_PURCHASE_ORDER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default DocGenPurchaseOrderRoute
